import React, { useEffect, useState, FC } from "react";
import { Row, Col, Table, Pagination, Button } from "antd";
import {
  columns,
  datahelper,
  handleUniqueGetList,
} from "../../helpers/sku.helper";
import { useSearchParams } from "react-router-dom";
import TableForm from "../../components/tableForm";
import SelectedSkuModal from "../../components/selectedSkuModal";
import { GetSkuList } from "../../api/sku";
import { SearchOutlined } from "@ant-design/icons";
import { filterParams } from "../../helpers/function.helper";
import { handleSelectRow } from "../../helpers/sku.helper";
import { FormattedMessage } from "react-intl";
import { useGlobalState } from "../../context/Provider";
import { useNavigate } from "react-router";
import NavigationMenu from "../../components/navigationMenu";
import TableTotalCount from "../../components/tableTotalCount";

const Sku: FC = () => {
  const [searchParams]: any = useSearchParams();
  const [loading, setLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [data, setData] = useState<any>([]);
  const [form, setForm] = useState<any>(Object.fromEntries([...searchParams]));
  const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]); // [1,2 ,4 ,6]
  const [selectRowSkus, setSelectRowSkus] = useState<any>([]); //[{} , {} , {}] for INfo
  const [visibleSelectSku, setVisibleSelectSku] = useState<boolean>(false);
  const [menuVisible, setMenuVisible] = useState(false);

  const { langState }: any = useGlobalState();

  const hasSelectRowKeys = selectedRowKeys.length;
  const navigate = useNavigate();

  useEffect(() => {
    handleGetList();
  }, [form, page]);

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    handleGetList(sorter.columnKey, sorter.order);
  };

  const handleGetList = (sorting?: string, order?: string) => {
    const params = {
      Sorting: sorting,
      order: order === "descend" ? true : false,
      SkipCount: (page - 1) * 40,
      ProductName: form.productName,
      ManufacturerId: form.ManufacturerId,
      Sku: form.Sku,
    };

    const filterParam = filterParams(params);

    setLoading(true);
    GetSkuList(filterParam).then((res: any) => {
      setLoading(false);
      console.log("GetSkuList", res);
      if (res.status === 200) {
        setTotal(res.data.totalCount);
        const newData = [
          ...data,
          ...datahelper(res.data.items, params.SkipCount),
        ];
        setData(handleUniqueGetList(newData));
        setMenuVisible(false);
      }
    });
  };

  const onSelectChange = (rowKeys: any) => {
    console.log("onSelectChange");
    const currentData = handleSelectRow(rowKeys, selectedRowKeys, page - 1);
    setSelectedRowKeys(currentData);
    const selectSuk = data.filter((elem: any) =>
      currentData.find((item: number) => elem.key === item)
    );
    setSelectRowSkus(selectSuk);
  };

  const handleOk = () => {
    setSelectRowSkus([]);
    setSelectedRowKeys([]);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const handleSetForm = (values: any) => {
    setPage(1);
    setData([]);
    setForm(values);
  };

  return (
    <>
      <Row gutter={[0, 24]} justify="center">
        <Col xs={0} md={23}>
          <TableForm setForm={handleSetForm} setFormData={()=>{}}/>
        </Col>
        <Col xs={23} md={0}>
          <NavigationMenu visible={menuVisible} setVisible={setMenuVisible} >
            <TableForm setForm={setForm} isMobile setFormData={()=>{}}/>
          </NavigationMenu>
        </Col>
        <Col span={23}>
          <Row gutter={[13, 10]}>
            <Col>
              <Button
                type="primary"
                disabled={hasSelectRowKeys ? false : true}
                onClick={() => setVisibleSelectSku(true)}
              >
                <FormattedMessage id="sku.addInBatchesSelected" />
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                onClick={() => navigate(`/panel/sku/towarehouse/group`)}
              >
                <FormattedMessage id="sku.addInBatches" />
              </Button>
            </Col>

            <Col md={0}>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => setMenuVisible(true)}
                className="d-flex align-items-center"
              >
                <div className="px-2">
                  <FormattedMessage id="sku.search" />
                </div>
              </Button>
            </Col>
          </Row>
        </Col>
        <Col span={23}>
          <Table
            rowSelection={rowSelection}
            columns={columns(langState.locale)}
            dataSource={data.filter(
              (item: any) =>
                item.key > (page - 1) * 40 && item.key <= (page - 1) * 40 + 40
            )}
            size="middle"
            pagination={false}
            scroll={{ x: 1100, y: "calc(100vh - 375px)" }}
            loading={loading}
            onChange={handleTableChange}
            expandable={{
              expandedRowRender: (record) => (
                <p style={{ margin: 0 }}>{record.description}</p>
              ),
            }}
          />
        </Col>
        <Col span={23}>
          <Row justify="space-between" align="middle">
            <Col>
              <Pagination
                defaultCurrent={1}
                total={total}
                defaultPageSize={40}
                showSizeChanger={false}
                onChange={(number) => setPage(number)}
              />
            </Col>
            <Col>
              <TableTotalCount total={total} />
            </Col>
          </Row>
        </Col>
      </Row>
      <SelectedSkuModal
        visible={visibleSelectSku}
        setVisible={setVisibleSelectSku}
        info={selectRowSkus}
        handleOk={handleOk}
      />
    </>
  );
};
export default Sku;
